import { useTranslation } from 'react-i18next';
import { ButtonPrimary } from '../../components/UI/Buttons';
import { ScriptService } from '../../controllers/ScriptService';
import { SvgAccess } from '../../icons';
import { AltiboxServiceLink } from '../../interfaces';
import style from './GetAccessContainer.module.scss';

const GetAccessContainer: React.FC = () => {
  const { t } = useTranslation();

  const bodyText = ScriptService.isDKUser()
    ? t('order streaming services dk users')
    : t('select streaming services with your points');
  const buttonText = ScriptService.isDKUser() ? t('order') : t('go to mine sider');

  const serviceLink = AltiboxServiceLink[ScriptService.isDKUser() ? 'DK' : 'NO'];

  return (
    <div className={style.container}>
      <div className={style.title_wrapper}>
        <h3>{t('how to get access')}</h3>
        <SvgAccess />
      </div>
      <div>{bodyText}</div>
      <a className={style.link_button} target="_blank" href={serviceLink} rel="noreferrer">
        <ButtonPrimary>{buttonText}</ButtonPrimary>
      </a>
    </div>
  );
};

export default GetAccessContainer;
